import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiZap, FiPlus } from 'react-icons/fi';
import AppsGrid from './AppsGrid';
import { getMacSsoToken } from '../../services/workflowService';
import './MacAppsPage.css';
const MacAppsPage: React.FC = () => {
    const [isRegistering, setIsRegistering] = useState(false);
    const [registerError, setRegisterError] = useState(false);
    const handleRegisterApp = async () => {
        setIsRegistering(true);
        setRegisterError(false);
        try {
            const amsToken = localStorage.getItem('amsToken') ?? '';
            const ssoToken = await getMacSsoToken(amsToken);
            window.open(`${(process.env.REACT_APP_FUSIONNOW_APP_URL)}/now-certs-auth?token=${encodeURIComponent(ssoToken)}&action=register-app-form`, '_blank');
        }
        catch {
            setRegisterError(true);
            setTimeout(() => setRegisterError(false), 3000);
        }
        finally {
            setIsRegistering(false);
        }
    };
    return (<div className='mac-apps-page'>
      <div className='mac-apps-page__header'>
        <div className='mac-apps-page__title-row'>
          <div className='mac-apps-page__title-left'>
            <div className='mac-apps-page__icon'>
              <FiZap size={15}/>
            </div>
            <h1 className='mac-apps-page__title'>MAC Apps</h1>
          </div>

          <motion.button className={`mac-apps-page__register-btn${registerError ? ' mac-apps-page__register-btn--error' : ''}`} onClick={handleRegisterApp} disabled={isRegistering} whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
            <FiPlus size={13}/>
            {isRegistering ? 'Opening…' : registerError ? 'Failed — retry' : 'Register App'}
          </motion.button>
        </div>
        <p className='mac-apps-page__subtitle'>
          Discover apps and integrations built for insurance agencies
        </p>
      </div>

      <AppsGrid />
    </div>);
};
export default MacAppsPage;
